import React, { useMemo, useState } from 'react';
import { confirmCrmHubSuggestions } from '../config/api';

const CrmBulkConfirmHubSuggestionsDialog = ({ leads, onClose, onSaved }) => {
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const suggestedLeads = useMemo(
    () => leads.filter((lead) => lead.suggestedHub && !(lead.hubLinks || []).length),
    [leads]
  );
  const groupedHubs = useMemo(() => {
    const groups = new Map();
    suggestedLeads.forEach((lead) => {
      const hub = lead.suggestedHub;
      const current = groups.get(hub.hubId) || { ...hub, count: 0 };
      current.count += 1;
      groups.set(hub.hubId, current);
    });
    return [...groups.values()];
  }, [suggestedLeads]);

  const submit = async () => {
    setSaving(true);
    setError('');
    try {
      const response = await confirmCrmHubSuggestions(
        suggestedLeads.map((lead) => lead.id)
      );
      if (onSaved) await onSaved(response?.data || response);
      onClose();
    } catch (err) {
      setError(err.message || 'Could not confirm the suggested hubs.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={saving ? undefined : onClose}>
      <div className="modal-content" onClick={(event) => event.stopPropagation()} style={{ maxWidth: '520px' }}>
        <div className="modal-header">
          <h3>Confirm suggested Hubs</h3>
          <button type="button" className="modal-close" onClick={onClose} disabled={saving}>×</button>
        </div>
        <div className="modal-body">
          <p className="crm-muted">
            Create Hub links for {suggestedLeads.length} selected Lead{suggestedLeads.length === 1 ? '' : 's'}.
            Leads without a unique suggestion will remain unchanged.
          </p>
          <div className="crm-suggestion-review-list">
            {groupedHubs.map((hub) => (
              <div key={hub.hubId} className="crm-suggestion-review-row">
                <div>
                  <strong>{hub.name || `Hub #${hub.hubId}`}</strong>
                  {(hub.city || hub.state) && (
                    <div className="crm-muted">{[hub.city, hub.state].filter(Boolean).join(', ')}</div>
                  )}
                </div>
                <span className="crm-chip">{hub.count} Lead{hub.count === 1 ? '' : 's'}</span>
              </div>
            ))}
          </div>
          {error && <div className="crm-form-error">{error}</div>}
        </div>
        <div className="modal-footer">
          <button type="button" className="btn btn-secondary" onClick={onClose} disabled={saving}>Cancel</button>
          <button type="button" className="btn btn-primary" onClick={submit} disabled={saving || suggestedLeads.length === 0}>
            {saving ? 'Confirming…' : 'Confirm Hub links'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CrmBulkConfirmHubSuggestionsDialog;
